import { styled } from "@linaria/react";
import type { QUANTITY_COLOR_INDEX } from "../useSelectedQuantities";
import {
  MAX_SELECTED_QUANTITIES,
  quantityColor,
  QUANTITY_COLOR_INDICES,
} from "../useSelectedQuantities";

export const colorClassName = (colorIndex: QUANTITY_COLOR_INDEX | undefined) =>
  colorIndex === undefined ? undefined : `color${colorIndex}`;

// we cannot use style or any kind of dynamic trick here (renderAsString + CSP)
const AxisTitle = styled.span`
  ${QUANTITY_COLOR_INDICES.map(
    index => `
      &.${colorClassName(index)} {
        color: ${quantityColor(index)};
      }
    `,
  ).join("")}
  font-weight: 600;
  & + & {
    margin-left: 10px;
  }
  &:nth-child(${MAX_SELECTED_QUANTITIES / 2 + 1}) {
    &::before {
      content: "";
      display: block;
    }
  }
`;

export default AxisTitle;
